import React from "react";
import { Dropdown, Space } from "antd";
import useAuth from "../../hooks/useAuth";
import { logoutUser } from "../../hooks/logoutUser";
import { ChevronDown } from "lucide-react";

const SelectProfile = () => {
  
  const { auth, setAuth } = useAuth();


  const logout = () => {
    logoutUser(setAuth); // ✅ handles everything
  };

  const items = [
    {
      label: "User Profile",
      key: "0",
    },
    {
      label: "Account Settings",
      key: "1",
    },
    {
      label: "Support",
      key: "3",
    },
    {
      label: "Logout",
      key: "4",
      onClick: logout,
    },
  ];
  return (
    <Dropdown menu={{ items }} trigger={["click"]} className="cusror-pointer">
      <Space style={{ cursor: "pointer" }}>
        {auth?.user?.firstname}
        {auth?.user?.lastname}
        <ChevronDown color="#005C53" size={30} />
      </Space>
    </Dropdown>
  );
};

export default SelectProfile;
